class VindiRefund {
    constructor() {
        this.init();
    }

    init() {
        this.appendBankFields();
        this.setupEventListeners();
        this.observeDOMChanges();
    }

    observeDOMChanges() {
        let timeout;
        const observer = new MutationObserver(() => {
            clearTimeout(timeout);
            timeout = setTimeout(() => {
                const refundTable = jQuery('.wc-order-refund-items table tbody');
                if (refundTable.length && !refundTable.find('#bank_code').length) {
                    this.appendBankFields();
                }
            }, 100);
        });

        const container = document.querySelector('#woocommerce-order-items');
        if (container) {
            observer.observe(container, {
                childList: true,
                subtree: true
            });
        }
    }

    getBankFieldsTemplate() {
        const bank_options = Object.entries(vindiRefund.availableBanks).map(([code, name]) => `<option value="${code}">${name}</option>`).join('');
        return `
            <tr>
            <td class="label">
                <label for="agency_number">Agência:</label>
            </td>
            <td class="total">
                <input type="text" class="short" id="agency_number" name="agency_number">
            </td>
            </tr>
            <tr>
            <td class="label">
                <label for="account_number">Número da Conta:</label>
            </td>
            <td class="total">
                <input type="text" class="short" id="account_number" name="account_number">
            </td>
            </tr>
            <tr>
            <td class="label">
                <label for="account_digit">Dígito:</label>
            </td>
            <td class="total">
                <input type="text" class="short" id="account_digit" name="account_digit">
            </td>
            </tr>
            <tr>
            <td class="label">
                <label for="bank_code">Banco:</label>
            </td>
            <td class="total">
                <select id="bank_code" name="bank_code" class="wc-enhanced-select" style="width: 100%;">
                    ${bank_options}
                </select>
            </td>
            </tr>
            <tr>
            <td class="label">
                <label for="account_type">Tipo de Conta:</label>
            </td>
            <td class="total">
                <select id="account_type" name="account_type" class="wc-enhanced-select">
                    <option value="C">Conta Corrente</option>
                    <option value="S">Conta Poupança</option>
                </select>
            </td>
            </tr>
        `;
    }

    appendBankFields() {
        const refundTable = jQuery('.wc-order-refund-items table tbody');
        if (!refundTable.length) {
            return;
        }
        refundTable.append(this.getBankFieldsTemplate());
    }

    setupEventListeners() {
        jQuery('#woocommerce-order-items').on('woocommerce_order_meta_box_do_refund_ajax_data', (event, data) => {
            data.agency_number = jQuery('#agency_number').val();
            data.account_number = jQuery('#account_number').val();
            data.account_digit = jQuery('#account_digit').val();
            data.bank_code = jQuery('#bank_code').val();
            data.account_type = jQuery('#account_type').val();
            return data;
        });
    }
}

jQuery(document).ready(() => new VindiRefund());
